module.exports = __webpack_public_path__ + "static/media/S1_00042.c8c71e41.jpg";